// extracted by mini-css-extract-plugin
export default {"textEllipsisTwoLine":"pdf_textEllipsisTwoLine__Losa8"};